import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import NoticeStoreListContainer from '../../../containers/notice/NoticeStoreListContainer';
import { NOTICE_STORE_PAGE_NAME } from '../../../constants/service/app/noticeStoreConstants';

const NoticeStoreList = () => {
  return (
    <PageTemplate pageName={NOTICE_STORE_PAGE_NAME.NOTICE_STORE_LIST}>
      <NoticeStoreListContainer />
    </PageTemplate>
  );
};

export default NoticeStoreList;
